// @generated by protoc-gen-es v2.11.0 with parameter "target=ts,import_extension=none"
// @generated from file chalk/aggregate/v1/backfill.proto (package chalk.aggregate.v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { AggregateTimeSeries } from "./timeseries_pb";
import { file_chalk_aggregate_v1_timeseries } from "./timeseries_pb";
import type { Duration, Timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_duration, file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file chalk/aggregate/v1/backfill.proto.
 */
export const file_chalk_aggregate_v1_backfill: GenFile = /*@__PURE__*/
  fileDesc("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", [file_chalk_aggregate_v1_timeseries, file_google_protobuf_duration, file_google_protobuf_timestamp]);

/**
 * @generated from message chalk.aggregate.v1.AggregateBackfillCostEstimate
 */
export type AggregateBackfillCostEstimate = Message<"chalk.aggregate.v1.AggregateBackfillCostEstimate"> & {
  /**
   * @generated from field: int64 max_buckets = 1;
   */
  maxBuckets: bigint;

  /**
   * @generated from field: int64 expected_buckets = 2;
   */
  expectedBuckets: bigint;

  /**
   * @generated from field: int64 expected_bytes = 3;
   */
  expectedBytes: bigint;

  /**
   * @generated from field: double expected_storage_cost = 4;
   */
  expectedStorageCost: number;

  /**
   * @generated from field: google.protobuf.Duration expected_runtime = 5;
   */
  expectedRuntime?: Duration;
};

/**
 * Describes the message chalk.aggregate.v1.AggregateBackfillCostEstimate.
 * Use `create(AggregateBackfillCostEstimateSchema)` to create a new message.
 */
export const AggregateBackfillCostEstimateSchema: GenMessage<AggregateBackfillCostEstimate> = /*@__PURE__*/
  messageDesc(file_chalk_aggregate_v1_backfill, 0);

/**
 * @generated from message chalk.aggregate.v1.AggregateBackfillUserParams
 */
export type AggregateBackfillUserParams = Message<"chalk.aggregate.v1.AggregateBackfillUserParams"> & {
  /**
   * @generated from field: repeated string features = 1;
   */
  features: string[];

  /**
   * @generated from field: optional string resolver = 2;
   */
  resolver?: string;

  /**
   * @generated from field: optional string timestamp_column_name = 3 [deprecated = true];
   * @deprecated
   */
  timestampColumnName?: string;

  /**
   * @generated from field: optional google.protobuf.Timestamp lower_bound = 4;
   */
  lowerBound?: Timestamp;

  /**
   * @generated from field: optional google.protobuf.Timestamp upper_bound = 5;
   */
  upperBound?: Timestamp;

  /**
   * @generated from field: bool exact = 6;
   */
  exact: boolean;

  /**
   * @generated from field: repeated string tags = 7;
   */
  tags: string[];

  /**
   * @generated from field: optional string input_sql = 8;
   */
  inputSql?: string;
};

/**
 * Describes the message chalk.aggregate.v1.AggregateBackfillUserParams.
 * Use `create(AggregateBackfillUserParamsSchema)` to create a new message.
 */
export const AggregateBackfillUserParamsSchema: GenMessage<AggregateBackfillUserParams> = /*@__PURE__*/
  messageDesc(file_chalk_aggregate_v1_backfill, 1);

/**
 * @generated from message chalk.aggregate.v1.AggregateBackfill
 */
export type AggregateBackfill = Message<"chalk.aggregate.v1.AggregateBackfill"> & {
  /**
   * @generated from field: repeated chalk.aggregate.v1.AggregateTimeSeries series = 1;
   */
  series: AggregateTimeSeries[];

  /**
   * @generated from field: string resolver = 2;
   */
  resolver: string;

  /**
   * @generated from field: string datetime_feature = 3;
   */
  datetimeFeature: string;

  /**
   * @generated from field: google.protobuf.Duration bucket_duration = 4;
   */
  bucketDuration?: Duration;

  /**
   * @generated from field: string filters_description = 5;
   */
  filtersDescription: string;

  /**
   * @generated from field: repeated string group_by = 6;
   */
  groupBy: string[];

  /**
   * @generated from field: google.protobuf.Duration max_retention = 7;
   */
  maxRetention?: Duration;

  /**
   * @generated from field: google.protobuf.Timestamp lower_bound = 8;
   */
  lowerBound?: Timestamp;

  /**
   * @generated from field: google.protobuf.Timestamp upper_bound = 9;
   */
  upperBound?: Timestamp;

  /**
   * @generated from field: optional string input_sql = 10;
   */
  inputSql?: string;
};

/**
 * Describes the message chalk.aggregate.v1.AggregateBackfill.
 * Use `create(AggregateBackfillSchema)` to create a new message.
 */
export const AggregateBackfillSchema: GenMessage<AggregateBackfill> = /*@__PURE__*/
  messageDesc(file_chalk_aggregate_v1_backfill, 2);

/**
 * @generated from message chalk.aggregate.v1.AggregateBackfillWithCostEstimate
 */
export type AggregateBackfillWithCostEstimate = Message<"chalk.aggregate.v1.AggregateBackfillWithCostEstimate"> & {
  /**
   * @generated from field: chalk.aggregate.v1.AggregateBackfill backfill = 1;
   */
  backfill?: AggregateBackfill;

  /**
   * @generated from field: chalk.aggregate.v1.AggregateBackfillCostEstimate estimate = 2 [deprecated = true];
   * @deprecated
   */
  estimate?: AggregateBackfillCostEstimate;
};

/**
 * Describes the message chalk.aggregate.v1.AggregateBackfillWithCostEstimate.
 * Use `create(AggregateBackfillWithCostEstimateSchema)` to create a new message.
 */
export const AggregateBackfillWithCostEstimateSchema: GenMessage<AggregateBackfillWithCostEstimate> = /*@__PURE__*/
  messageDesc(file_chalk_aggregate_v1_backfill, 3);

/**
 * @generated from message chalk.aggregate.v1.AggregateBackfillJob
 */
export type AggregateBackfillJob = Message<"chalk.aggregate.v1.AggregateBackfillJob"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string environment_id = 2;
   */
  environmentId: string;

  /**
   * @generated from field: optional string resolver = 3;
   */
  resolver?: string;

  /**
   * @generated from field: repeated string features = 4;
   */
  features: string[];

  /**
   * @generated from field: optional string agent_id = 5;
   */
  agentId?: string;

  /**
   * @generated from field: optional string deployment_id = 6;
   */
  deploymentId?: string;

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 7;
   */
  createdAt?: Timestamp;

  /**
   * @generated from field: google.protobuf.Timestamp updated_at = 8;
   */
  updatedAt?: Timestamp;

  /**
   * @generated from field: repeated string resolvers = 9;
   */
  resolvers: string[];

  /**
   * @generated from field: optional string cron_aggregate_backfill_id = 10;
   */
  cronAggregateBackfillId?: string;

  /**
   * @generated from field: optional string plan_hash = 11;
   */
  planHash?: string;

  /**
   * @generated from field: chalk.aggregate.v1.AggregateBackfillStatus status = 12;
   */
  status: AggregateBackfillStatus;

  /**
   * @generated from field: repeated string query_tags = 13;
   */
  queryTags: string[];

  /**
   * @generated from field: optional string cron_aggregate_backfill_name = 14;
   */
  cronAggregateBackfillName?: string;
};

/**
 * Describes the message chalk.aggregate.v1.AggregateBackfillJob.
 * Use `create(AggregateBackfillJobSchema)` to create a new message.
 */
export const AggregateBackfillJobSchema: GenMessage<AggregateBackfillJob> = /*@__PURE__*/
  messageDesc(file_chalk_aggregate_v1_backfill, 4);

/**
 * @generated from message chalk.aggregate.v1.CronAggregateBackfill
 */
export type CronAggregateBackfill = Message<"chalk.aggregate.v1.CronAggregateBackfill"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string environment_id = 2;
   */
  environmentId: string;

  /**
   * @generated from field: string deployment_id = 3;
   */
  deploymentId: string;

  /**
   * @generated from field: string name = 11;
   */
  name: string;

  /**
   * @generated from field: string schedule = 4;
   */
  schedule: string;

  /**
   * @generated from field: optional string filename = 12;
   */
  filename?: string;

  /**
   * @generated from field: string plan_hash = 5;
   */
  planHash: string;

  /**
   * @generated from field: repeated string features = 8;
   */
  features: string[];

  /**
   * @generated from field: repeated string resolvers = 9;
   */
  resolvers: string[];

  /**
   * @generated from field: repeated string query_tags = 10;
   */
  queryTags: string[];

  /**
   * TODO: deprecate
   *
   * @generated from field: chalk.aggregate.v1.AggregateBackfillTarget target = 13;
   */
  target: AggregateBackfillTarget;

  /**
   * @generated from field: optional string resource_group = 14;
   */
  resourceGroup?: string;

  /**
   * @generated from field: repeated chalk.aggregate.v1.AggregateBackfillTarget targets = 15;
   */
  targets: AggregateBackfillTarget[];

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 6;
   */
  createdAt?: Timestamp;

  /**
   * @generated from field: google.protobuf.Timestamp updated_at = 7;
   */
  updatedAt?: Timestamp;
};

/**
 * Describes the message chalk.aggregate.v1.CronAggregateBackfill.
 * Use `create(CronAggregateBackfillSchema)` to create a new message.
 */
export const CronAggregateBackfillSchema: GenMessage<CronAggregateBackfill> = /*@__PURE__*/
  messageDesc(file_chalk_aggregate_v1_backfill, 5);

/**
 * @generated from enum chalk.aggregate.v1.AggregateBackfillStatus
 */
export enum AggregateBackfillStatus {
  /**
   * @generated from enum value: AGGREGATE_BACKFILL_STATUS_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: AGGREGATE_BACKFILL_STATUS_INITIALIZING = 1;
   */
  INITIALIZING = 1,

  /**
   * @generated from enum value: AGGREGATE_BACKFILL_STATUS_INIT_FAILED = 2;
   */
  INIT_FAILED = 2,

  /**
   * @generated from enum value: AGGREGATE_BACKFILL_STATUS_SKIPPED = 3;
   */
  SKIPPED = 3,

  /**
   * init completed
   *
   * @generated from enum value: AGGREGATE_BACKFILL_STATUS_QUEUED = 4;
   */
  QUEUED = 4,

  /**
   * @generated from enum value: AGGREGATE_BACKFILL_STATUS_WORKING = 5;
   */
  WORKING = 5,

  /**
   * @generated from enum value: AGGREGATE_BACKFILL_STATUS_COMPLETED = 6;
   */
  COMPLETED = 6,

  /**
   * @generated from enum value: AGGREGATE_BACKFILL_STATUS_FAILED = 7;
   */
  FAILED = 7,

  /**
   * @generated from enum value: AGGREGATE_BACKFILL_STATUS_CANCELED = 8;
   */
  CANCELED = 8,
}

/**
 * Describes the enum chalk.aggregate.v1.AggregateBackfillStatus.
 */
export const AggregateBackfillStatusSchema: GenEnum<AggregateBackfillStatus> = /*@__PURE__*/
  enumDesc(file_chalk_aggregate_v1_backfill, 0);

/**
 * @generated from enum chalk.aggregate.v1.AggregateBackfillTarget
 */
export enum AggregateBackfillTarget {
  /**
   * @generated from enum value: AGGREGATE_BACKFILL_TARGET_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: AGGREGATE_BACKFILL_TARGET_ONLINE = 1;
   */
  ONLINE = 1,

  /**
   * @generated from enum value: AGGREGATE_BACKFILL_TARGET_OFFLINE = 2;
   */
  OFFLINE = 2,

  /**
   * Publish compact online aggregate summaries.
   *
   * @generated from enum value: AGGREGATE_BACKFILL_TARGET_ONLINE_SUMMARIES = 3;
   */
  ONLINE_SUMMARIES = 3,
}

/**
 * Describes the enum chalk.aggregate.v1.AggregateBackfillTarget.
 */
export const AggregateBackfillTargetSchema: GenEnum<AggregateBackfillTarget> = /*@__PURE__*/
  enumDesc(file_chalk_aggregate_v1_backfill, 1);

